const LS_BUILD_REVISION_KEY = 'bono_shell_build_revision';

function readBuildRevisionFromEnv(): string {
  try {
    return (import.meta.env.ADMIN_BUILD_REVISION ?? '').trim();
  } catch {
    return '';
  }
}

const EMBEDDED_BUILD_REVISION = readBuildRevisionFromEnv();

export function getEmbeddedShellBuildRevision(): string {
  return EMBEDDED_BUILD_REVISION;
}

export function readStoredShellBuildRevision(): string | null {
  try {
    if (globalThis.localStorage === undefined) return null;
    return globalThis.localStorage.getItem(LS_BUILD_REVISION_KEY);
  } catch {
    return null;
  }
}

export function writeStoredShellBuildRevision(): void {
  if (!EMBEDDED_BUILD_REVISION) return;
  try {
    if (globalThis.localStorage === undefined) return;
    globalThis.localStorage.setItem(LS_BUILD_REVISION_KEY, EMBEDDED_BUILD_REVISION);
  } catch {
    /* ignore persistence failures */
  }
}

/** True when a previous build revision was stored and differs from the current bundle. */
export function didShellBuildRevisionChange(previous: string | null): boolean {
  if (!EMBEDDED_BUILD_REVISION || !previous) return false;
  return previous !== EMBEDDED_BUILD_REVISION;
}
